// This file is AUTOGENERATED, do not edit it manually!!!

export const menu = {
    dashboard: 'Quadro di comando',
    notifications: 'Impostazioni di notifica',
    portfolios: 'Portfolios',
    reports: 'I Report',
    resourcesPage: 'Risorse',
    roles: 'Ruoli',
    search: 'Ricerca',
    updateLicense: 'Aggiornamento licenza',
};
